<template>
<div>
  <v-row align="center">
    <v-col cols="auto">
      <span class="font-weight-bold"> Visualizar por:</span>
    </v-col>
    <v-col>
      <SGPRadioGroupComponent
          titulo="Visualizar por:"
          :options="tiposVisualizacao"
          v-model="tipoVisualizacao"
          row>
      </SGPRadioGroupComponent>
    </v-col>
  </v-row>
    
  <!-- lista por status -->
  <span v-if="tipoVisualizacao == 1">
    <v-data-table
      :headers="getHeadersTotais()"
      :items="lista"
      item-key="item"
      class="custom_table elevation-4 black"
      item-class="bg-error"
      hide-default-footer
      disable-sort
    >
      <template v-slot:item.item>
        <span class="text-black">TOTAL</span>
      </template>
      <template v-slot:item.qtd_pendentes="{ item }">
        <span class="cursor-pointer" @click="detalharTarefas($event,null,null,1,0,0,null)">{{ item.qtd_pendentes }}</span>
      </template>
      <template v-slot:item.qtd_interrompidas="{ item }">
        <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,1,0,null)">{{ item.qtd_interrompidas }}</span>
      </template>
      <template v-slot:item.qtd_em_cancelamento="{ item }" v-if="mostrarCancelamento">
        <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,1,null)">{{ item.qtd_em_cancelamento }}</span>
      </template>
      <template v-slot:item.qtd_total="{ item }">
        <span class="cursor-pointer" @click="detalharTarefas($event,null,null,0,0,0,null)">{{ item.qtd_total }}</span>
      </template>

    </v-data-table>
  </span>
  <span v-else>
    <TabelaAgingComponent
      :lista="listaTabelaAging"
      @detalharTarefasEmit="detalharTarefasSelecao"
      :descricaoTitulo="'TOTAL'"
      :descricaoTabela="'Processo'"
      :nivelUnico="true"
    />
  </span>
</div>  
</template>

<script>
import { mapGetters } from 'vuex';
import TabelaAgingComponent from '../components/TabelaAgingComponent.vue'
export default {
  name: "TabelaTotalComponent",
  components: { 
    TabelaAgingComponent
  },
  props: {
    lista: {
      type: Array,
      required:false,
      default: () => []
    },
    descricaoTitulo: {
      type: String,
      required: true
    },
    descricaoTabela: {
      type: String,
      required: true
    },
    mostrarCancelamento: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    return {
      singleExpand: false,
      btnExpand: false,
      expanded: [],
      tipoVisualizacao: 1,
      tiposVisualizacao: [
        {label: 'Status', value: 1, class: 'mr-15'},
        {label: 'Aging', value: 2},
      ],
    }
  },

  methods: {
    toggleExpand(item) {
      this.expanded = this.expanded[0] === item ? [] : [item];
    },

    detalharTarefasSelecao (obj){
      this.$emit('detalharTarefasEmit', obj);
    },
    
    detalharTarefas (event, ctrlProcesso,ctrlTarefa,emAtendimento,interrompida,emCancelamento,aging,ctrlFamiliaId=null) {
      this.$emit('detalharTarefasEmit', {
        event,
        ctrlProcesso,
        ctrlTarefa,
        emAtendimento,
        interrompida,
        emCancelamento,
        aging,
        ctrlFamiliaId
      });
    },

    getHeadersTotais () {
      return this.headers.filter(header => {
        return !this.mostrarCancelamento && header.value == 'qtd_em_cancelamento' ? false : true
      })
    },

    expandAll (items) {            
      if (!this.btnExpand) {
        this.expanded = items
      } else {
        this.expanded = []
      }
      this.btnExpand = !this.btnExpand
    },

  },

  computed: {
    ...mapGetters('backlog', 
    [
      'listaTarefas',
      'loadingBacklog'
    ]),

    listaTabelaAging () {
      return  {
        itens: [
          {
            aging: { ...this.lista[0].aging },
            item: 'TOTAL'
          }
        ]
      } ;
    },

    headers () {
      return [
      { 
            text: this.descricaoTabela,
            align: 'start',
            value: 'item',
            width: '355px'
          },
          { 
            text: 'Em atendimento',
            align: 'center',
            value: 'qtd_pendentes',
            width: '150px'
          },
          { 
            text: 'SLA Tarefa',
            align: 'center',
            value: '',
            width: '130px'   
          },
          { 
            text: 'Fora SLA %',
            align: 'center',
            value: 'percentual_fora_sla',
            width: '130px'
          },
          { 
            text: 'Interrompidas',
            align: 'center',
            value: 'qtd_interrompidas',
            width: '130px'
          },        
          { 
            text: 'Em Cancelamento',
            align: 'center',
            value: 'qtd_em_cancelamento',
            width: '150px'
          },
          { 
            text: 'Total',
            align: 'center',
            value: 'qtd_total',
            width: '130px'
          },
          { 
            text: '',
            align: 'center',
            value: '',
          },
      ]
    },

  },

}
</script>